/*
This is the old skeleton for eip preview page that is currently being used by Rewards Page
*/
import React, { PureComponent } from 'react'
import BEMHelper from '@ynap/bem-helper'
import Skeleton from '@ynap/skeleton'

const bem = new BEMHelper('EIPLandingSkeleton')

class EIPLandingSkeleton extends PureComponent {
    render() {
        return (
            <div className={bem()}>
                <div className={bem('banner')} />
                <div className={bem('section')}>
                    <Skeleton align="center" className={bem('title', 'subtitle')} />
                    <Skeleton align="center" className={bem('title')} />
                    <div className={bem('paragraph')}>
                        <Skeleton count={3} align="center" />
                    </div>
                    <Skeleton align="center" className={bem('cta')} />
                </div>
                <div className={bem('divider')} />

                <div className={bem('section', 'timeline')}>
                    <Skeleton count={2} align="center" className={bem('title')} />
                    <div className={bem('paragraph')}>
                        <Skeleton count={2} align="center" />
                    </div>
                    <Skeleton align="center" className={bem('timeline')} />
                </div>

                <div className={bem('section', 'videoSmall')}>
                    <div className={bem('section')}>
                        <Skeleton align="center" className={bem('title')} />
                        <Skeleton align="center" className={bem('title', 'subtitle')} />
                    </div>
                    <div className={bem('post')}>
                        <div className={bem('image')} />
                        <div className={bem('postParagraph')}>
                            <Skeleton count={4} align="left" />
                        </div>
                    </div>
                </div>
                <div className={bem('section', 'videoLarge')} />
            </div>
        )
    }
}

export default EIPLandingSkeleton
